import { render, staticRenderFns } from "./Receiver.vue?vue&type=template&id=cbb84a88&scoped=true&"
import script from "./Receiver.vue?vue&type=script&lang=js&"
export * from "./Receiver.vue?vue&type=script&lang=js&"
import style0 from "./Receiver.vue?vue&type=style&index=0&id=cbb84a88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb84a88",
  null
  
)

export default component.exports